(function () {
  const hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
  let activeDropdown = null;
  let activeMenuItem = null;
  let closeDropdownTimer;

  function setDetailsState(details, isOpen) {
    const summary = details.querySelector('summary');
    details.open = isOpen;
    if (summary) {
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  function closeOtherMenus(currentDetails) {
    document.querySelectorAll('.section-header .header__inline-menu details[open]').forEach((details) => {
      if (details !== currentDetails) {
        setDetailsState(details, false);
      }
    });
  }

  function getTopMenuItems() {
    return document.querySelectorAll('.section-header .header__inline-menu > .list-menu--inline > li');
  }

  function getMenuTrigger(menuItem) {
    return (
      menuItem.querySelector(':scope > a.header__menu-item') ||
      menuItem.querySelector(':scope > header-menu > details > summary')
    );
  }

  function setupHeaderHoverLabels() {
    getTopMenuItems().forEach((menuItem) => {
      const trigger = getMenuTrigger(menuItem);
      if (!trigger) return;

      const labelSource = trigger.querySelector(':scope > span') || trigger;
      const label = labelSource.textContent.trim().replace(/\s+/g, ' ');

      if (label) {
        trigger.dataset.skim1Label = label;
      }
    });
  }

  function getCustomDropdown(menuItem, index) {
    const trigger = getMenuTrigger(menuItem);
    const text = (trigger ? trigger.textContent : menuItem.textContent).trim().toUpperCase();

    if (text.includes('WOMEN')) {
      return document.querySelector('.header_down_2');
    }

    if (text.includes('MEN')) {
      return document.querySelector('.header_down_1');
    }

    if (index > 0 && index < 3) {
      return document.querySelector(`.header_down_${index}`);
    }

    return null;
  }

  function updateDropdownTop() {
    const headerSection = document.querySelector('.section-header');
    if (!headerSection) return;

    const bottom = Math.max(0, Math.round(headerSection.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--skim1-header-down-top', `${bottom}px`);
  }

  function setDropdownState(dropdown, isOpen) {
    dropdown.classList.toggle('is-open', isOpen);
    dropdown.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  function closeCustomDropdown() {
    document.querySelectorAll('.header_down.is-open').forEach((dropdown) => {
      setDropdownState(dropdown, false);
    });

    getTopMenuItems().forEach((menuItem) => {
      menuItem.classList.remove('skim1-menu-active');
    });

    activeDropdown = null;
    activeMenuItem = null;
    document.body.classList.remove('skim1-custom-menu-open');
  }

  function openCustomDropdown(dropdown, menuItem) {
    if (!hoverQuery.matches || !dropdown) return;

    window.clearTimeout(closeDropdownTimer);
    updateDropdownTop();
    closeOtherMenus();

    document.querySelectorAll('.header_down').forEach((panel) => {
      setDropdownState(panel, panel === dropdown);
    });

    getTopMenuItems().forEach((item) => {
      item.classList.toggle('skim1-menu-active', item === menuItem);
    });

    const details = menuItem.querySelector(':scope > header-menu > details');
    if (details) {
      setDetailsState(details, false);
      window.requestAnimationFrame(() => setDetailsState(details, false));
    }

    activeDropdown = dropdown;
    activeMenuItem = menuItem;
    document.body.classList.add('skim1-custom-menu-open');
  }

  function scheduleCloseCustomDropdown() {
    if (!hoverQuery.matches) return;

    window.clearTimeout(closeDropdownTimer);
    closeDropdownTimer = window.setTimeout(() => {
      const focusInsideDropdown = activeDropdown && activeDropdown.contains(document.activeElement);
      const focusInsideMenuItem = activeMenuItem && activeMenuItem.contains(document.activeElement);
      const pointerInsideDropdown = activeDropdown && activeDropdown.matches(':hover');
      const pointerInsideMenuItem = activeMenuItem && activeMenuItem.matches(':hover');

      if (focusInsideDropdown || focusInsideMenuItem || pointerInsideDropdown || pointerInsideMenuItem) return;

      closeCustomDropdown();
    }, 140);
  }

  function setupCustomDropdownPanels() {
    document.querySelectorAll('.header_down').forEach((dropdown) => {
      if (dropdown.dataset.skim1PanelReady === 'true') return;
      dropdown.dataset.skim1PanelReady = 'true';
      dropdown.setAttribute('aria-hidden', 'true');

      dropdown.addEventListener('mouseenter', () => {
        if (!hoverQuery.matches) return;
        window.clearTimeout(closeDropdownTimer);
      });

      dropdown.addEventListener('mouseleave', scheduleCloseCustomDropdown);
      dropdown.addEventListener('focusin', () => {
        if (!hoverQuery.matches) return;
        window.clearTimeout(closeDropdownTimer);
      });
      dropdown.addEventListener('focusout', scheduleCloseCustomDropdown);
    });
  }

  function setupHeaderHoverMenus() {
    setupHeaderHoverLabels();
    setupCustomDropdownPanels();
    updateDropdownTop();

    getTopMenuItems().forEach((menuItem, index) => {
      if (menuItem.dataset.skim1HoverReady === 'true') return;
      menuItem.dataset.skim1HoverReady = 'true';

      const customDropdown = getCustomDropdown(menuItem, index);
      const trigger = getMenuTrigger(menuItem);
      const details = menuItem.querySelector(':scope > header-menu > details');
      let closeTimer;

      if (customDropdown) {
        menuItem.classList.add('skim1-menu-has-custom-dropdown');
        const openPanel = () => openCustomDropdown(customDropdown, menuItem);

        menuItem.addEventListener('mouseenter', openPanel);
        menuItem.addEventListener('mouseleave', scheduleCloseCustomDropdown);
        menuItem.addEventListener('focusin', openPanel);
        menuItem.addEventListener('focusout', scheduleCloseCustomDropdown);

        if (trigger && trigger.tagName === 'SUMMARY') {
          trigger.addEventListener('click', (event) => {
            if (!hoverQuery.matches) return;
            event.preventDefault();
            openPanel();
          });
        }

        return;
      }

      menuItem.addEventListener('mouseenter', () => {
        if (!hoverQuery.matches) return;
        closeCustomDropdown();
      });

      if (!details) return;

      const openMenu = () => {
        if (!hoverQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeCustomDropdown();
        closeOtherMenus(details);
        setDetailsState(details, true);
      };

      const closeMenu = () => {
        if (!hoverQuery.matches) return;
        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            setDetailsState(details, false);
          }
        }, 120);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      details.addEventListener('focusin', openMenu);
      details.addEventListener('focusout', closeMenu);
    });
  }

  const productsUnavailablePopupHashes = ['#products-unavailable-popup', '#products-unavailable'];

  function getProductsUnavailablePopup() {
    return document.querySelector('[data-products-unavailable-popup]');
  }

  function isProductsUnavailablePopupLink(link) {
    const rawHref = (link.getAttribute('href') || '').trim();

    if (!rawHref) return false;
    if (productsUnavailablePopupHashes.includes(rawHref)) return true;

    try {
      const url = new URL(link.href, window.location.href);

      return (
        productsUnavailablePopupHashes.includes(url.hash) ||
        url.searchParams.get('products_unavailable_popup') === 'true'
      );
    } catch (error) {
      return false;
    }
  }

  function closeHeaderDrawerFromLink(link) {
    const drawer = link.closest('header-drawer');
    const details = drawer ? drawer.querySelector('#Details-menu-drawer-container') : null;
    const summary = details ? details.querySelector('summary') : null;

    if (drawer && details && summary && details.hasAttribute('open') && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(new Event('click'), summary);
    }
  }

  function closeProductsUnavailablePopup() {
    const popup = getProductsUnavailablePopup();

    if (!popup) return;

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('products-unavailable-popup-open');

    if (
      window.__skim1ProductsUnavailablePopupPreviousFocus &&
      typeof window.__skim1ProductsUnavailablePopupPreviousFocus.focus === 'function'
    ) {
      window.__skim1ProductsUnavailablePopupPreviousFocus.focus({ preventScroll: true });
    }

    window.__skim1ProductsUnavailablePopupPreviousFocus = null;
  }

  function openProductsUnavailablePopup(opener) {
    const popup = getProductsUnavailablePopup();

    if (!popup) return false;

    setupProductsUnavailablePopup();
    window.__skim1ProductsUnavailablePopupPreviousFocus = opener || document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('products-unavailable-popup-open');

    window.requestAnimationFrame(() => {
      const dialog = popup.querySelector('[data-products-unavailable-popup-dialog]');

      if (dialog) dialog.focus({ preventScroll: true });
    });

    return true;
  }

  function setupProductsUnavailablePopup() {
    const popup = getProductsUnavailablePopup();

    if (!popup) return;

    if (popup.dataset.skim1PopupReady !== 'true') {
      popup.dataset.skim1PopupReady = 'true';
      popup.querySelectorAll('[data-products-unavailable-popup-close]').forEach((button) => {
        button.addEventListener('click', closeProductsUnavailablePopup);
      });
    }

    if (!window.__skim1ProductsUnavailablePopupTriggerBound) {
      window.__skim1ProductsUnavailablePopupTriggerBound = true;
      document.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest('a[href]');

          if (!link || !isProductsUnavailablePopupLink(link) || !getProductsUnavailablePopup()) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          closeCustomDropdown();
          closeOtherMenus();
          closeHeaderDrawerFromLink(link);
          openProductsUnavailablePopup(link);
        },
        true
      );
    }

    if (!window.__skim1ProductsUnavailablePopupKeyBound) {
      window.__skim1ProductsUnavailablePopupKeyBound = true;
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeProductsUnavailablePopup();
      });
    }
  }

  function setupHeaderInteractions() {
    setupHeaderHoverMenus();
    setupProductsUnavailablePopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHeaderInteractions);
  } else {
    setupHeaderInteractions();
  }

  document.addEventListener('shopify:section:load', setupHeaderInteractions);
  window.addEventListener('resize', updateDropdownTop);
  window.addEventListener('scroll', updateDropdownTop, { passive: true });
})();
